import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { epicsErrorHandler } from '../../../epics'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../PartnerOptions/constants'
import { QUICK_FILTERS_CHANGE } from '../QuickFilters/constants'

import { fetchDataError, fetchDataSuccess } from './actions'
import {
  DATA_REQUEST_ASYNC,
  GENERAL_FILTER_CHANGE,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SET_DETECTED_BY_FILTER,
} from './constants'
import { selectDetectedByFilter } from './selectors'

const fetchDataEpic = (action$, store, { api }) =>
  action$
    .ofType(
      DATA_REQUEST_ASYNC.INITIATE,
      SEARCH_CHANGE,
      PAGINATE_CHANGE,
      QUICK_FILTERS_CHANGE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      GENERAL_FILTER_CHANGE,
      SET_DETECTED_BY_FILTER
    )
    .filter((action) => {
      if (
        action.type === QUICK_FILTERS_CHANGE ||
        action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
      )
        return matchURL(URL_CONST.incidents.reported)
      return true
    })
    .switchMap(() =>
      api.resolutionCenter
        .getReportedIncidents(
          store.getState().resolutioncenter.reportedIncidents.page || 1,
          store.getState().resolutioncenter.reportedIncidents.search,
          store.getState().resolutioncenter.reportedIncidents.generalFilter,
          selectDetectedByFilter(store.getState())?.map((elem) => elem.value),
          store.getState().resolutioncenter.quickFilters.quickFilters,
          store.getState().partnerOptions.selectedCompany?.value
        )
        .map((response) => fetchDataSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchDataError, error)))
        .takeUntil(action$.ofType(DATA_REQUEST_ASYNC.CANCEL))
    )

export default combineEpics(fetchDataEpic)
